module.exports = __webpack_public_path__ + "img/plus_btn_small.332804c1.svg";